/* VESSIL product page: bundle picker, subscription toggle, live prices, video pop-up, accordions, delivery dates. */
(function () {
  function money(cents, symbol) {
    var n = cents / 100;
    var whole = Math.abs(n - Math.round(n)) < 0.005;
    return symbol + (whole ? Math.round(n).toLocaleString('en-US') : n.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }));
  }

  document.querySelectorAll('[data-vf-pdp]').forEach(function (root) {
    var data = {};
    try { data = JSON.parse(root.querySelector('[data-vf-variant]').textContent); } catch (e) { return; }
    var sym = root.dataset.currency || '$';
    var days = parseInt(root.dataset.days, 10) || 30;
    var qtyInput = root.querySelector('[data-vf-qty]');
    var planInput = root.querySelector('[data-vf-plan]');
    var planSelect = root.querySelector('[data-vf-plan-select]');
    var sub = root.querySelector('[data-vf-sub]');
    var subToggle = root.querySelector('[data-vf-sub-toggle]');
    var bundles = root.querySelectorAll('[data-vf-bundle]');
    var ctaPrice = root.querySelector('[data-vf-cta-price]');
    var priceNow = root.querySelector('[data-vf-price]');
    var subPrice = root.querySelector('[data-vf-sub-price]');

    function subscribed() { return !!(subToggle && subToggle.checked && planPrice() !== null); }

    /* One-time packs and the subscription are separate choices: a subscription is one tube per delivery,
       so picking it clears the pack rows, and picking a pack clears the subscription. */
    var idInput = root.querySelector('[data-vf-id]');
    var variants = data.variants || {};
    function activeRow() { return root.querySelector('[data-vf-bundle].is-active'); }
    function selectedVariant() { var a = activeRow(); var vid = a && a.dataset.variant; return (vid && variants[vid]) ? { id: vid, v: variants[vid] } : { id: String(data.id), v: { price: data.price, plans: data.plans || {}, available: data.available } }; }
    function planPriceFor(vr) { if (!planSelect) return null; var p = vr.plans && vr.plans[planSelect.value]; return typeof p === 'number' ? p : null; }
    /* the subscription always means the base variant (one tube) on the chosen plan */
    var baseVariant = variants[String(data.id)] || { price: data.price, plans: data.plans || {}, available: data.available };
    function planPrice() { return planPriceFor(baseVariant); }
    function current() {
      var sel = selectedVariant();
      if (subscribed()) return { id: String(data.id), qty: 1, save: 0, unit: planPrice(), total: planPrice() };
      var active = activeRow();
      if (active && active.dataset.variant) return { id: sel.id, qty: 1, save: 0, unit: sel.v.price, total: sel.v.price };
      var qty = active ? parseInt(active.dataset.qty, 10) || 1 : 1;
      var save = active ? parseInt(active.dataset.save, 10) || 0 : 0;
      var unit = Math.round(data.price * (1 - save / 100));
      return { id: String(data.id), qty: qty, save: save, unit: unit, total: unit * qty };
    }

    function render() {
      bundles.forEach(function (b) {
        if (b.dataset.variant) return;
        var q = parseInt(b.dataset.qty, 10) || 1, sv = parseInt(b.dataset.save, 10) || 0;
        var unit = Math.round(data.price * (1 - sv / 100));
        var total = unit * q;
        var t = b.querySelector('[data-vf-total]'), w = b.querySelector('[data-vf-was]'), sup = b.querySelector('[data-vf-supply]'), pd = b.querySelector('[data-vf-perday]');
        if (t) t.textContent = money(total, sym);
        if (w) w.textContent = money(data.price * q, sym);
        if (sup) sup.textContent = (days * q) + ' day supply';
        if (pd) pd.textContent = money(Math.round(total / (days * q)), sym);
      });
      var c = current();
      if (idInput) idInput.value = c.id;
      if (sub) { var hasPlan = planPrice() !== null; sub.classList.toggle('is-disabled', !hasPlan); if (!hasPlan && subToggle && subToggle.checked) { subToggle.checked = false; c = current(); } }
      if (qtyInput) qtyInput.value = c.qty;
      if (planInput) { planInput.disabled = !subscribed(); planInput.value = subscribed() ? planSelect.value : ''; }
      if (sub) sub.classList.toggle('is-active', !!(subToggle && subToggle.checked));
      if (subPrice && planPrice() !== null) subPrice.textContent = money(planPrice(), sym);
      if (ctaPrice) ctaPrice.textContent = money(c.total, sym);
      var stickyPrice = root.querySelector('[data-vf-cta-price-sticky]'); if (stickyPrice) stickyPrice.textContent = money(c.total, sym);
      if (priceNow) priceNow.textContent = money(data.price, sym);
    }

    var defaultBundle = root.querySelector('[data-vf-bundle].is-active') || bundles[0] || null;
    function clearBundles() { bundles.forEach(function (o) { o.classList.remove('is-active'); var i = o.querySelector('input[type=radio]'); if (i) i.checked = false; }); }
    bundles.forEach(function (b) {
      var input = b.querySelector('input[type=radio]');
      function pick() { clearBundles(); b.classList.add('is-active'); if (input) input.checked = true; if (subToggle) subToggle.checked = false; render(); }
      b.addEventListener('click', function (e) { if (e.target.tagName !== 'INPUT') { e.preventDefault(); } pick(); });
      if (input) input.addEventListener('change', pick);
    });
    if (subToggle) {
      subToggle.addEventListener('change', function () {
        if (subToggle.checked) { clearBundles(); }
        else if (!root.querySelector('[data-vf-bundle].is-active') && defaultBundle) { defaultBundle.classList.add('is-active'); var i = defaultBundle.querySelector('input[type=radio]'); if (i) i.checked = true; }
        render();
      });
      if (subToggle.checked) clearBundles();
    }
    if (planSelect) planSelect.addEventListener('change', render);
    if (sub) sub.addEventListener('click', function (e) { if (e.target.closest('select')) e.stopPropagation(); });
    render();

    /* delivery dates */
    var tl = root.querySelector('[data-vf-timeline]');
    if (tl) {
      var fmt = function (d) { return d.toLocaleDateString('en-US', { month: 'short', day: '2-digit' }); };
      var add = function (n) { var d = new Date(); d.setDate(d.getDate() + n); return d; };
      var ranges = { ready: (root.dataset.ready || '0,6').split(','), deliver: (root.dataset.deliver || '5,12').split(',') };
      tl.querySelectorAll('[data-vf-date]').forEach(function (el) {
        var k = el.dataset.vfDate; var r = ranges[k] || k.split(',');
        var a = parseInt(r[0], 10) || 0, b = parseInt(r[1], 10) || 0;
        el.textContent = a === b ? fmt(add(a)) : fmt(add(a)) + ' - ' + fmt(add(b));
      });
    }

    /* sticky add-to-cart bar (phones): shows once the main button has scrolled above the viewport */
    var sticky = root.querySelector('[data-vf-sticky]'), mainCta = root.querySelector('.vf-pdp__cta');
    if (sticky && mainCta && 'IntersectionObserver' in window) {
      sticky.hidden = false;
      var stickyBtn = sticky.querySelector('[data-vf-sticky-btn]');
      if (stickyBtn) stickyBtn.addEventListener('click', function () { mainCta.click(); });
      /* the observed area runs from the viewport top down to infinity, so the callback fires exactly when the
         button crosses the top edge, even on a fast fling that never has it in view */
      new IntersectionObserver(function (entries) {
        var e = entries[0]; var passed = !e.isIntersecting && e.boundingClientRect.top < 0;
        sticky.classList.toggle('is-on', passed); document.body.classList.toggle('vf-sticky-open', passed);
      }, { threshold: 0, rootMargin: '0px 0px 100000px 0px' }).observe(mainCta);
    }

    /* mobile gallery arrows (the gallery becomes a swipe carousel below 900px) */
    var gal = root.querySelector('[data-vf-gallery]');
    if (gal) {
      var galStep = function () { return gal.clientWidth + 8; };
      var gp = root.querySelector('[data-vf-gal-prev]'), gn = root.querySelector('[data-vf-gal-next]');
      if (gp) gp.addEventListener('click', function () { gal.scrollBy({ left: -galStep(), behavior: 'smooth' }); });
      if (gn) gn.addEventListener('click', function () { gal.scrollBy({ left: galStep(), behavior: 'smooth' }); });
    }

    /* video pop-up */
    var dlg = root.querySelector('[data-vf-video]');
    if (dlg) {
      var frame = dlg.querySelector('iframe[data-src]'); var vid = dlg.querySelector('video');
      root.querySelectorAll('[data-vf-video-open]').forEach(function (b) {
        b.addEventListener('click', function () { if (frame && frame.src === 'about:blank') frame.src = frame.dataset.src; dlg.showModal(); if (vid) vid.play().catch(function () {}); });
      });
      var close = function () { if (vid) vid.pause(); if (frame) frame.src = 'about:blank'; dlg.close(); };
      dlg.querySelectorAll('[data-vf-video-close]').forEach(function (b) { b.addEventListener('click', close); });
      dlg.addEventListener('click', function (e) { if (e.target === dlg) close(); });
      dlg.addEventListener('close', function () { if (vid) vid.pause(); if (frame) frame.src = 'about:blank'; });
    }
  });

  /* accordions: optional single-open behaviour */
  document.querySelectorAll('[data-vf-accordion][data-single]').forEach(function (group) {
    group.addEventListener('toggle', function (e) {
      var d = e.target; if (!(d instanceof HTMLDetailsElement) || !d.open) return;
      group.querySelectorAll('details[open]').forEach(function (o) { if (o !== d) o.open = false; });
    }, true);
  });
})();
